import { CreateRequest, Customer, Result } from "@models";
import requests from "./agent";
import dayjs from "dayjs";
import { getAttribution } from "../shared/analytics";

export const requestService = {
  create: async (request: CreateRequest) => {
    const response = await requests.post<Result<Customer>>(
      "/api/Request/Create",
      { ...getAttribution(), ...request, date: dayjs(request.date).format("YYYY-MM-DD") }
    );
    return response.result;
  },
};
